import { authRoles } from 'app/auth';
import VizsgaFeladatTable from './table/VizsgaFeladatTable';
import VizsgaFeladatEditForm from './editform/VizsgaFeladatEditForm';

export default [
	{
		path: '/vizsga-feladat/edit/:id/:vizsgafeladatsor',
		component: VizsgaFeladatEditForm,
		auth: authRoles.admin
	},
	{
		path: '/vizsga-feladat/:vizsgafeladatsor/:sessionNameParam?',
		component: VizsgaFeladatTable,
		auth: authRoles.admin
	}
];
